export const logError = (context) => (e) => {
  console.warn(`[Path-Intelligent] ${context}:`, e?.response?.status || "", e?.message || e);
};
